export default ".txt-bold {\n  font-weight: bold;\n}";